import { ScaleInfo, ScaleService } from 'src/app/services/scale.service';
import { SpatialUnits } from './../../model/Pixospatial';
import { SLMap } from 'src/app/model/sl-map';
import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy, HostBinding, ElementRef } from '@angular/core';
import { NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';
import { Map } from 'mapbox-gl';
import { HexString } from 'src/app/types/@types/hex-string';

@Component({
  selector: 'app-scale-bar',
  templateUrl: './scale-bar.component.html',
  styleUrls: ['./scale-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScaleBarComponent implements OnInit, OnDestroy {
  @HostBinding('style.width') styleWidth = '1in';
  @HostBinding('style.--color') styleColor = '#fff';

  private _initialized = false;

  private _units: SpatialUnits = 'imperial-auto';
  private lastCenter?: string;
  private lastZoom?: number;

  @Input() set color(val: HexString) {
    this.styleColor = val as string;
  }
  private _interactive: boolean = false;
  @Input() interactive(val: 'true' | 'false') {
    this._interactive = (val === 'true');
  }
  set units(u: SpatialUnits) {
    this._units = u;
    this.lastCenter = undefined;
    this.lastZoom = undefined;
    this.UpdateScale();
  }
  get unitString(): string {
    if (!this._scale?.units) return '';
    return this._scale.units.split('-').pop();
  }
  public updateHandler;
  private _map?: SLMap;
  @Input() set map(map: SLMap) {
    this._map = map;
    if (!this._map.ui) {
      setTimeout(() => {
        this.map = map;
      }, 1)
      return;
    }
    const me = this;
    this.updateHandler = (e) => {
     if(this.lastZoom === this._map.ui.getZoom()) return;
      this.lastZoom = this._map.ui.getZoom();
      me.UpdateScale();
    }
    this._map.ui.on('moveend', this.updateHandler);
    this._map.ui.on('zoomend', this.updateHandler);
    this._map.ui.on('dragend', this.updateHandler);


    if (this._initialized) {
      this._ready = true;

      this.UpdateScale();
    }

  }

  public get distance(): string {
    if (!this._scale) return '';
    let distance = this._scale.length;
    let modified = false;
    if (this._scale?.precisionType === 'manual') {
      if (this._scale.precision !== undefined) {
        distance = Number(this._scale.length.toPrecision(this._scale.precision));
        modified = true;
      }
    }
    if (!modified) distance = Math.round(distance);
    return NumberQualifierService.ToString(distance, 'comma-dot');
  }
  public get unit(): string {
    if (!this._scale) return '';
    return this._scale.units.split('-').pop();
  }
  private _scale?: ScaleInfo;
  constructor(private cdr: ChangeDetectorRef, private domNode: ElementRef<HTMLDivElement>) {

  }

  private _ready = false;
  private _bounced = false;
  ngOnInit(): void {
    this._initialized = true;
    if (this._interactive) {
      this.domNode.nativeElement.addEventListener('click', () => {
        this._bounced = false;
        window.setTimeout(() => {
          if (this._bounced === true) return;
          this.CycleUnits();

        }, 500);
      })
      this.domNode.nativeElement.addEventListener('dblclick', () => {
        this._bounced = true;
        this.CycleAutoUnits();
      })
    };
    if (!this._map) return;
    this._ready = true;
    this.UpdateScale();
  }
  UpdateScale() {
    if (!this._map?.ui) return;
    this._scale = this._map.GetMapScale(this._map.scaleUnits);

    let distance = NumberQualifierService.FromString(this.distance, 'comma-dot');
    if (this._scale?.precisionType === 'manual') {
      if (this._scale?.precision !== undefined) {
        distance = Number(distance.toPrecision(this._scale.precision <4 ? 4 : this._scale.precision));
      }
    }
    this._scale.pxDistance = this._map.GetScalePx(distance, this._scale?.units);
    ScaleService.SetScale(this._scale);
    this.styleWidth = this._scale.pxDistance + 'px';
    this.Refresh();
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
  CycleUnits() {
    if (!this._scale) return;
    if (!this._map) return;
    const units = ['meters-m', 'meters-km', 'imperial-ft', 'imperial-mi'];
    let offset = units.indexOf(this._scale.units);
    offset += 1;
    if (offset >= units.length) offset = 0;
    this.units = units[offset] as SpatialUnits;
    this._map.scaleUnits = units[offset] as SpatialUnits;
    this.UpdateScale();
  }
  CycleAutoUnits() {
    if (!this._scale) return;
    if (!this._map) return;

    if (this._map.scaleUnits.split('-')[0] === 'meters') {
      this._map.scaleUnits = 'imperial-auto';
    } else {
      this._map.scaleUnits = 'meters-auto';
    }
    this.UpdateScale();
  }

  ngOnDestroy() {
    if (!this._map) return;
    this._map.ui.off('moveend', this.updateHandler);
    this._map.ui.off('zoomend', this.updateHandler);
    this._map.ui.off('dragend', this.updateHandler);



  }

}
